import styled, { css } from 'styled-components';

import { tagColorType } from './colorType';
import { ColorType, SizeType } from './type';

const BaseAvatar = styled.div<{ size_type: SizeType }>`
	${({ size_type }) =>
		size_type === 'small' &&
		css`
			width: 32px;
			height: 32px;
		`}
	${({ size_type }) =>
		size_type === 'default' &&
		css`
			width: 48px;
			height: 48px;
		`}
    ${({ size_type }) =>
		size_type === 'large' &&
		css`
			width: 80px;
			height: 80px;
		`}
    
    ${({ theme }) => theme.common.flexCenter};

	border: 1px solid ${({ theme }) => theme.colors.gray.gray15};
`;

export const TextAvatar = styled(BaseAvatar)<{
	color_type: ColorType;
	is_picture: boolean;
	is_click?: boolean;
	_disabled?: boolean;
}>`
	border-radius: 8px;

	${({ theme }) => theme.typo.body.p_bold}

	${({ color_type }) => color_type === 'gray' && tagColorType.gray};
	${({ color_type }) => color_type === 'black' && tagColorType.black};
	${({ color_type }) => color_type === 'red' && tagColorType.red};
	${({ color_type }) => color_type === 'yellow' && tagColorType.yellow};
	${({ color_type }) => color_type === 'green' && tagColorType.green};
	${({ color_type }) => color_type === 'blue' && tagColorType.blue};

	${({ _disabled }) =>
		_disabled &&
		css`
			${tagColorType.gray};
			filter: grayscale(1);
		`}

	overflow: hidden;
	flex-shrink: 0;

	${({ is_picture }) => is_picture && `background-color: transparent`};
	${({ is_click }) => is_click && `cursor: pointer`};
`;

export const PictureAvatar = styled(TextAvatar)`
	border-radius: 50%;
	overflow: hidden;
	isolation: isolate;
`;

export const PictureWrapper = styled.div<{ picture?: string }>`
	width: 100%;
	height: 100%;

	background-image: url(${({ picture }) => picture});
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
`;

export const AvatarGroup = styled.div`
	display: flex;

	& > div {
		border: 2px solid ${({ theme }) => theme.colors.gray.gray_white};
	}

	& > div:not(:first-of-type) {
		margin-left: -8px;
	}
`;

export const PictureEllipsis = styled.div`
	width: 32px;
	height: 32px;
	border-radius: 50%;
	background-color: ${({ theme }) => theme.colors.gray.gray15};
	color: ${({ theme }) => theme.colors.gray.gray80_text};
	font-weight: ${({ theme }) => theme.font.weight.bold};
	font-size: 11px;
	${({ theme }) => theme.common.flexCenter};
`;
